export default "__VITE_ASSET__DtHSe847__"